/* @luxottica/vm-glasses v9.0.0 */
import { RemoteLogConfig, RemoteLog } from '@luxottica/vm-remotelog';
import JSZip from 'jszip';

const name="@luxottica/vm-glasses";const version="9.0.0";

const hosts = {
    MOCK: {
        name: 'PROD',
        catalogHost: 'https://vmcore.luxottica.com',
        transitionHost: 'https://qa-gw-api-vtocatalogue.luxdeepblue.com',
        b3dHost: 'https://vmcore.luxottica.com',
        gltfHost: 'https://mobile-catalogue-3d-model-test.s3-accelerate.amazonaws.com/public/vto-poc',
        gltfPointer: '/pointers/gltf',
        customDistributorHost: 'https://distributor-distributor.luxdeepblue.com',
        customDistributorKey: 'HnqGNWeO.Px2v1cUrm3ffk6gC0OOdTgJRoaOfxClC',
        customDistributorGetPermutation: '/api/getPermutation?token=',
        assetType: 'SEPARATE'
    },
    PROD: {
        name: 'PROD',
        catalogHost: 'https://vmcore.luxottica.com',
        transitionHost: 'https://gw-api-vtocatalogue.luxdeepblue.com',
        b3dHost: 'https://vmcore.luxottica.com',
        gltfHost: 'https://vmcore.luxottica.com/api/upc/v1',
        gltfPointer: '/pointers/gltf',
        customDistributorHost: 'https://distributor-distributor.luxdeepblue.com',
        customDistributorKey: 'HnqGNWeO.Px2v1cUrm3ffk6gC0OOdTgJRoaOfxClC',
        customDistributorGetPermutation: '/api/getPermutation?token=',
        assetType: 'SEPARATE'
    },
    PROD_LEGACY: {
        name: 'PROD_LEGACY',
        catalogHost: 'https://vmcore.luxottica.com',
        transitionHost: 'https://gw-api-vtocatalogue.luxdeepblue.com',
        b3dHost: 'https://vto-3d-assets.luxdeepblue.com',
        gltfHost: 'https://vmcore.luxottica.com/api/upc/v1',
        gltfPointer: '/pointers/gltf',
        customDistributorHost: 'https://distributor-distributor.luxdeepblue.com',
        customDistributorKey: 'HnqGNWeO.Px2v1cUrm3ffk6gC0OOdTgJRoaOfxClC',
        customDistributorGetPermutation: '/api/getPermutation?token=',
        assetType: 'ZIPPED'
    },
    TEST: {
        name: 'TEST',
        catalogHost: 'https://vmcore-test.luxottica.com',
        transitionHost: 'https://test-api-vtocatalogue.luxdeepblue.com',
        b3dHost: 'https://vmcore-test.luxottica.com',
        gltfHost: 'https://vmcore-test.luxottica.com/api/upc/v1',
        gltfPointer: '/pointers/gltf',
        customDistributorHost: 'https://staging-distributor-distributor.luxdeepblue.com',
        customDistributorKey: 'bMhq6JPO.nLtuIsJU61lazsX3pnj10iH0wv2Dr7KA',
        customDistributorGetPermutation: '/api/getPermutation?token=',
        assetType: 'ZIPPED'
    },
    TEST_LEGACY: {
        name: 'TEST_LEGACY',
        catalogHost: 'https://test-api-vtocatalogue.luxdeepblue.com',
        transitionHost: 'https://test-gw-api-vtocatalogue.luxdeepblue.com',
        b3dHost: 'https://vto-3d-assets-test.luxdeepblue.com',
        gltfHost: 'https://vmcore-test.luxottica.com/api/upc/v1',
        gltfPointer: '/pointers/gltf',
        customDistributorHost: 'https://staging-distributor-distributor.luxdeepblue.com',
        customDistributorKey: 'bMhq6JPO.nLtuIsJU61lazsX3pnj10iH0wv2Dr7KA',
        customDistributorGetPermutation: '/api/getPermutation?token=',
        assetType: 'SEPARATE'
    },
    QA_GLTF_PROD: {
        name: 'QA_PROD',
        catalogHost: 'https://vmcore.luxottica.com',
        transitionHost: 'https://qa-gw-api-vtocatalogue.luxdeepblue.com',
        b3dHost: 'https://s3.amazonaws.com/vto-3d-assets-qa',
        gltfHost: 'https://gw-api-vtocatalogue.luxdeepblue.com/api/upc/v1',
        gltfPointer: '/pointers/gltf?qa=true',
        customDistributorHost: 'https://distributor-distributor.luxdeepblue.com',
        customDistributorKey: 'HnqGNWeO.Px2v1cUrm3ffk6gC0OOdTgJRoaOfxClC',
        customDistributorGetPermutation: '/api/getPermutation?token=',
        assetType: 'ZIPPED'
    },
    QA_GLTF_TEST: {
        name: 'QA_TEST',
        catalogHost: 'https://test-api-vtocatalogue.luxdeepblue.com',
        transitionHost: 'https://qa-gw-api-vtocatalogue.luxdeepblue.com',
        b3dHost: 'https://s3.amazonaws.com/vto-3d-assets-qa-test',
        gltfHost: 'https://vmcore-test.luxottica.com/api/upc/v1',
        gltfPointer: '/pointers/gltf?qa=true',
        customDistributorHost: 'https://staging-distributor-distributor.luxdeepblue.com',
        customDistributorKey: 'bMhq6JPO.nLtuIsJU61lazsX3pnj10iH0wv2Dr7KA',
        customDistributorGetPermutation: '/api/getPermutation?token=',
        assetType: 'ZIPPED'
    },
    QA_B3D_PROD: {
        name: 'QA_PROD',
        catalogHost: 'https://vmcore.luxottica.com',
        transitionHost: 'https://qa-gw-api-vtocatalogue.luxdeepblue.com',
        b3dHost: 'https://s3.amazonaws.com/vto-3d-assets-qa',
        gltfHost: 'https://gw-api-vtocatalogue.luxdeepblue.com/api/upc/v1',
        gltfPointer: '/pointers/gltf?qa=true',
        customDistributorHost: 'https://distributor-distributor.luxdeepblue.com',
        customDistributorKey: 'HnqGNWeO.Px2v1cUrm3ffk6gC0OOdTgJRoaOfxClC',
        customDistributorGetPermutation: '/api/getPermutation?token=',
        assetType: 'ZIPPED'
    },
    QA_B3D_TEST: {
        name: 'QA_TEST',
        catalogHost: 'https://test-api-vtocatalogue.luxdeepblue.com',
        transitionHost: 'https://qa-gw-api-vtocatalogue.luxdeepblue.com',
        b3dHost: 'https://s3.amazonaws.com/vto-3d-assets-qa-test',
        gltfHost: 'https://test-api-vtocatalogue.luxdeepblue.com/api/upc/v1',
        gltfPointer: '/pointers/gltf?qa=true',
        customDistributorHost: 'https://staging-distributor-distributor.luxdeepblue.com',
        customDistributorKey: 'bMhq6JPO.nLtuIsJU61lazsX3pnj10iH0wv2Dr7KA',
        customDistributorGetPermutation: '/api/getPermutation?token=',
        assetType: 'ZIPPED'
    },
    // environments for distributor developments
    DISTRIBUTOR_VALIDATION_STAGING: {
        name: 'DISTRIBUTOR_VALIDATION_STAGING',
        catalogHost: 'https://test-api-vtocatalogue.luxdeepblue.com',
        transitionHost: 'https://qa-gw-api-vtocatalogue.luxdeepblue.com',
        b3dHost: 'https://distributor-assets-staging.s3.amazonaws.com/validation',
        gltfHost: '',
        gltfPointer: '',
        customDistributorHost: '',
        customDistributorKey: '',
        customDistributorGetPermutation: '/api/getPermutation?token=',
        assetType: 'ZIPPED'
    },
    DISTRIBUTOR_APPROVATION_STAGING: {
        name: 'DISTRIBUTOR_APPROVATION_STAGING',
        catalogHost: 'https://test-api-vtocatalogue.luxdeepblue.com',
        transitionHost: 'https://qa-gw-api-vtocatalogue.luxdeepblue.com',
        b3dHost: 'https://distributor-assets-staging.s3.amazonaws.com/approvation',
        gltfHost: '',
        gltfPointer: '',
        customDistributorHost: '',
        customDistributorKey: '',
        customDistributorGetPermutation: '/api/getPermutation?token=',
        assetType: 'ZIPPED'
    },
    DISTRIBUTOR_VALIDATION_PRODUCTION: {
        name: 'DISTRIBUTOR_VALIDATION_PRODUCTION',
        catalogHost: 'https://vmcore.luxottica.com',
        transitionHost: 'https://qa-gw-api-vtocatalogue.luxdeepblue.com',
        b3dHost: 'https://distributor-assets-production.s3.amazonaws.com/validation',
        gltfHost: '',
        gltfPointer: '',
        customDistributorHost: '',
        customDistributorKey: '',
        customDistributorGetPermutation: '/api/getPermutation?token=',
        assetType: 'ZIPPED'
    },
    DISTRIBUTOR_APPROVATION_PRODUCTION: {
        name: 'DISTRIBUTOR_APPROVATION_PRODUCTION',
        catalogHost: 'https://vmcore.luxottica.com',
        transitionHost: 'https://qa-gw-api-vtocatalogue.luxdeepblue.com',
        b3dHost: 'https://distributor-assets-production.s3.amazonaws.com/approvation',
        gltfHost: '',
        gltfPointer: '',
        customDistributorHost: '',
        customDistributorKey: '',
        customDistributorGetPermutation: '/api/getPermutation?token=',
        assetType: 'ZIPPED'
    }
};
const getEnvironmentConfig = (env) => {
    return (env) ? hosts[env] : hosts.PROD;
};

const upcsAvailabilityApiV2 = '/api/upc/v2/{upcs}/availability';
const transitionColorApi = '/api/transition/v2/vocabulary';
const CatalogueApiConfig = {
    getUpcsAvailabilityApiEndpoint(config, upcString) {
        const envConfig = getEnvironmentConfig(config.env);
        //TODO: remove after prod api is complete
        if (config.env.includes('TEST')) {
            return `${envConfig.catalogHost}${upcsAvailabilityApiV2}`.replace('{upcs}', upcString);
        }
        else {
            return (!!config.key) ?
                `${envConfig.catalogHost}${upcsAvailabilityApiV2}`.replace('{upcs}', upcString)
                :
                    `${envConfig.catalogHost}${upcsAvailabilityApiV2}`.replace('{upcs}', upcString);
        }
    },
    getTransitionEndpoint(config) {
        const envConfig = getEnvironmentConfig(config.env);
        return `${envConfig.transitionHost}${transitionColorApi}`;
    }
};

const notAvailableResponse = (upc) => {
    return {
        upc: upc,
        available: { 256: false, 512: false },
        transitions: { 256: false, 512: false },
        lods: [],
        glassesType: undefined,
        getUpc: () => upc,
        isAvailable: () => false,
        isTransition: () => false,
    };
};

// inside the QA tool every asset is considered fully available
const qaToolAvailability = (upc, config) => {
    return {
        upc: upc,
        available: { 256: true, 512: true },
        transitions: { 256: true, 512: true },
        lods: [0, 1, 2],
        getUpc: () => upc,
        // we need somehow to split between b3d and gltf files somehow
        glassesType: config.env.includes('GLTF') ? 'GLTF' : 'B3D',
        isAvailable: () => true,
        isTransition: () => true,
    };
};

const getGlassesType = (lods, config, isAvailable) => {
    // TODO: remove this. To support MOCK env is necessary to return GLTF as glasses type in case the upc is not supported
    return (lods.length > 0 || config.env === 'MOCK' && !isAvailable) ? 'GLTF' : 'B3D';
};
const standardResponse = (catalogResponse, upc, config) => {
    const lods = (!!(catalogResponse === null || catalogResponse === void 0 ? void 0 : catalogResponse.lods)) ? catalogResponse.lods : [];
    const isAvailable = catalogResponse.resolutions.includes('PX_256') || catalogResponse.resolutions.includes('PX_512') || lods.length > 0;
    const isTransition = catalogResponse.transitionsResolutions.includes('PX_256')
        || catalogResponse.transitionsResolutions.includes('PX_512');
    const glassesType = getGlassesType(lods, config, isAvailable);
    return {
        upc: upc,
        available: {
            '256': catalogResponse.resolutions.includes('PX_256'),
            '512': catalogResponse.resolutions.includes('PX_512')
        },
        transitions: {
            '256': catalogResponse.transitionsResolutions.includes('PX_256'),
            '512': catalogResponse.transitionsResolutions.includes('PX_512'),
        },
        lods,
        glassesType,
        getUpc: () => upc,
        isAvailable: () => isAvailable,
        isTransition: () => isTransition,
    };
};

const logger = RemoteLogConfig.getInstance().getLoggerInfo(name, version, 'CatalogService');
const fetchCatalogResponse = (config, upc) => {
    const apiEndpoint = CatalogueApiConfig.getUpcsAvailabilityApiEndpoint(config, upc);
    const requestInit = {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...(config.key && { 'x-api-key': config.key })
        },
        mode: 'cors',
        referrerPolicy: 'unsafe-url',
    };
    return fetch(apiEndpoint, requestInit);
};
const CatalogService = {
    getUpcAvailability(config, upc) {
        // inside the QA tool there's no UPC availability API for unpublished assets
        if (config.env.includes('QA')) {
            return Promise.resolve(qaToolAvailability(upc, config));
        }
        // otherwise we fetch the answer from remote
        return fetchCatalogResponse(config, upc)
            .then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error(`catalog failed to respond. Response status: ${response.status}`);
        }).then((json) => {
            if (!!json[upc]) {
                return standardResponse(json[upc], upc, config);
            }
            return notAvailableResponse(upc);
        });
    },
    downloadTransitionColors(config) {
        const apiEndpoint = CatalogueApiConfig.getTransitionEndpoint(config);
        return fetch(apiEndpoint).then((response) => {
            return response.json();
        }).then((json) => {
            try {
                const result = {};
                json.forEach((color) => {
                    result[color.name] = {
                        mirror: color.mirror,
                        active: color.active,
                        clear: color.clear
                    };
                });
                return result;
            }
            catch (e) {
                logger.error(e);
            }
            return {};
        });
    }
};

const logger$1 = RemoteLogConfig.getInstance().getLoggerInfo(name, version, 'Catalog');
const Catalog = {
    getUpcAvailability(config, upc) {
        logger$1.info('getUpcAvailability for {}', upc);
        return CatalogService.getUpcAvailability(config, upc);
    },
    // getUpcsAvailability(
    //   config: CatalogConfiguration,
    //   ...upcs: string[]
    // ): Promise<{ [upc: string]: UpcAvailability }> {
    //   return CatalogService.getUpcsAvailability(config, ...upcs);
    // },
    downloadTransitionColors(config) {
        logger$1.info('downloadTransitionColors');
        return CatalogService.downloadTransitionColors(config);
    }
};

var GlassesEnvironment;
(function (GlassesEnvironment) {
    GlassesEnvironment["PROD"] = "PROD";
    GlassesEnvironment["PROD_LEGACY"] = "PROD_LEGACY";
    GlassesEnvironment["TEST"] = "TEST";
    GlassesEnvironment["TEST_LEGACY"] = "TEST_LEGACY";
    GlassesEnvironment["QA_GLTF_PROD"] = "QA_GLTF_PROD";
    GlassesEnvironment["QA_GLTF_TEST"] = "QA_GLTF_TEST";
    GlassesEnvironment["QA_B3D_PROD"] = "QA_B3D_PROD";
    GlassesEnvironment["QA_B3D_TEST"] = "QA_B3D_TEST";
    GlassesEnvironment["MOCK"] = "MOCK";
    // environments for distributor developments
    GlassesEnvironment["DISTRIBUTOR_VALIDATION_STAGING"] = "DISTRIBUTOR_VALIDATION_STAGING";
    GlassesEnvironment["DISTRIBUTOR_APPROVATION_STAGING"] = "DISTRIBUTOR_APPROVATION_STAGING";
    GlassesEnvironment["DISTRIBUTOR_VALIDATION_PRODUCTION"] = "DISTRIBUTOR_VALIDATION_PRODUCTION";
    GlassesEnvironment["DISTRIBUTOR_APPROVATION_PRODUCTION"] = "DISTRIBUTOR_APPROVATION_PRODUCTION";
})(GlassesEnvironment || (GlassesEnvironment = {}));

const AssetDecoder = {
    getArrayBuffer(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onerror = reject;
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.readAsArrayBuffer(blob);
        });
    },
    getZippedImage(imagePromise) {
        return imagePromise
            .async('blob')
            .then((blob) => {
            return AssetDecoder.getImage(blob);
        });
    },
    getImage(blob) {
        return new Promise((resolve, reject) => {
            const url = URL.createObjectURL(blob);
            const img = new Image();
            img.crossOrigin = '*';
            img.onload = () => {
                URL.revokeObjectURL(url);
                resolve(img);
            };
            img.onerror = (e) => {
                reject(e);
            };
            img.src = url;
        });
    },
    getImageBase64(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onerror = reject;
            reader.onload = () => {
                resolve('' + reader.result);
            };
            reader.readAsDataURL(blob);
        });
    },
    getZippedGLTF(upc, gltfPromise) {
        return gltfPromise
            .async('blob')
            .then((blob) => {
            return AssetDecoder.getGLTFAsset(upc, blob);
        });
    },
    getGLTFAsset(upc, blob) {
        return this.getArrayBuffer(blob)
            .then((arrayBuffer) => {
            return Promise.resolve({
                upc,
                arrayBuffer,
            });
        });
    },
};

const assetNames = {
    b3d: 'glasses.b3d',
    transparency: 'mult.jpg',
    shadow: 'shadow-crop.jpg',
    lensMap: 'lens-map.png',
    lensBounds: 'bounds.glb',
    glassesLandmarks: 'landmarks.glb',
    color: (index) => `color-${index}.jpg`,
};

/*
This has been written during the mocking phase, during the integration of
Luxottica's GTLF format. Probably will be useful with third parites glasses.
*/
const gltfDefaults = {
    nosepad_type: 'integrated',
    fitting: 'standard',
    flare: 0.025,
};

const MockAssetData = {
    'RB2140ROSETTA001': {
        'nosepad_type': 'integrated',
        'flare': 0.023,
        'fitting': 'standard',
        'lodNumber': 2,
        'misc': false
    },
    'RB2140ROSETTA002': {
        'nosepad_type': 'integrated',
        'flare': 0.023,
        'fitting': 'standard',
        'lodNumber': 2,
        'misc': false
    },
    'RB3025ROSETTA001': {
        'nosepad_type': 'floating',
        'flare': 0.025,
        'fitting': 'standard',
        'lodNumber': 2,
        'misc': true
    },
    'OO9406ROSETTA001': {
        'nosepad_type': 'integrated',
        'flare': 0.024,
        'fitting': 'standard',
        'lodNumber': 2,
        'misc': false
    },
    'THIRDPARTYROSETTA-NOGROUP': {
        'nosepad_type': 'undefined',
        'flare': 0.025,
        'fitting': 'fast',
        'lodNumber': 1,
        'misc': false
    },
    'THIRDPARTYROSETTA-WGROUP': {
        'nosepad_type': 'undefined',
        'flare': 0.025,
        'fitting': 'fast',
        'lodNumber': 1,
        'misc': false
    },
    'dbyd_dbsu5003_8719154814969': {
        'nosepad_type': 'undefined',
        'flare': 0.025,
        'fitting': 'fast',
        'lodNumber': 1,
        'misc': false
    },
    'unofficial_unsf0146_8719154842764': {
        'nosepad_type': 'undefined',
        'flare': 0.025,
        'fitting': 'fast',
        'lodNumber': 1,
        'misc': false
    },
    'unofficial_unsu0094_8719154843136': {
        'nosepad_type': 'undefined',
        'flare': 0.025,
        'fitting': 'fast',
        'lodNumber': 1,
        'misc': false
    },
    'dbyd_dbsm0029_8719154744198': {
        'nosepad_type': 'undefined',
        'flare': 0.025,
        'fitting': 'fast',
        'lodNumber': 1,
        'misc': false
    },
    'fb-quality': {
        'nosepad_type': 'undefined',
        'flare': 0.025,
        'fitting': 'fast',
        'lodNumber': 1,
        'misc': false
    },
    'fb-standard': {
        'nosepad_type': 'undefined',
        'flare': 0.025,
        'fitting': 'fast',
        'lodNumber': 1,
        'misc': false
    },
    'costa00000001': {
        'nosepad_type': 'undefined',
        'flare': 0.025,
        'fitting': 'fast',
        'lodNumber': 1,
        'misc': false
    },
    'goccia00000001': {
        'nosepad_type': 'undefined',
        'flare': 0.025,
        'fitting': 'fast',
        'lodNumber': 1,
        'misc': false
    },
    'frogskins00000001': {
        'nosepad_type': 'undefined',
        'flare': 0.025,
        'fitting': 'fast',
        'lodNumber': 1,
        'misc': false
    },
    'A03116ROSETTA003': {
        'nosepad_type': 'integrated',
        'flare': 0.025,
        'fitting': 'standard',
        'lodNumber': 2,
        'misc': false
    },
    'DG4315BROSETTA001': {
        'nosepad_type': 'integrated',
        'flare': 0.025,
        'fitting': 'standard',
        'lodNumber': 2,
        'misc': false
    },
    'HC6149ROSETTA001': {
        'nosepad_type': 'integrated',
        'flare': 0.025,
        'fitting': 'standard',
        'lodNumber': 2,
        'misc': false
    },
    'OO9013ROSETTA001': {
        'nosepad_type': 'integrated',
        'flare': 0.025,
        'fitting': 'standard',
        'lodNumber': 2,
        'misc': false
    },
    '06A2003VROSETTA001': {
        'nosepad_type': 'integrated',
        'flare': 0.025,
        'fitting': 'standard',
        'lodNumber': 2,
        'misc': false
    },
    'OO9102ROSETTA001': {
        'nosepad_type': 'integrated',
        'flare': 0.025,
        'fitting': 'standard',
        'lodNumber': 2,
        'misc': false
    },
    'PO3210SROSETTA001': {
        'nosepad_type': 'integrated',
        'flare': 0.025,
        'fitting': 'standard',
        'lodNumber': 2,
        'misc': false
    },
    'RB3016ROSETTA001': {
        'nosepad_type': 'integrated',
        'flare': 0.025,
        'fitting': 'standard',
        'lodNumber': 2,
        'misc': false
    },
    '06S4010ROSETTA001': {
        'nosepad_type': 'integrated',
        'flare': 0.025,
        'fitting': 'standard',
        'lodNumber': 2,
        'misc': false
    },
    'OO9406ROSETTA002': {
        'nosepad_type': 'integrated',
        'flare': 0.025,
        'fitting': 'standard',
        'lodNumber': 2,
        'misc': false
    },
};

class GenericError extends Error {
    constructor(type, message) {
        super(`${type}: ${message}`);
        this.genericError = true;
        this.type = type;
        this.message = message;
        Object.setPrototypeOf(this, new.target.prototype);
    }
    getType() {
        return this.type;
    }
}

class GlassesDownloadError extends GenericError {
    constructor(upc) {
        super('GlassesDownloadError', `glasses for upc ${upc} download failed`);
        this.upc = upc;
    }
}

class GlassesDownloadForbiddenError extends GenericError {
    constructor(upc) {
        super('GlassesDownloadForbiddenError', `glasses archive for upc ${upc} download forbidden`);
        this.upc = upc;
    }
}

class GlassesNotFoundError extends GenericError {
    constructor(upc) {
        super('GlassesNotFoundError', `glasses archive for upc ${upc} not found`);
        this.upc = upc;
    }
}

const isDistributorAsset = (upc) => {
    return upc.startsWith('TKN~');
};
const isQADistributorAsset = (upc) => {
    // sample QA distributor UPC: 0OO9290CP-FRAME_SR005
    const dash = upc.split('-').length > 1;
    const underscore = upc.split('_').length > 1;
    return dash && underscore;
};
const distributorBasename = (upc) => {
    // sample distributor UPC: 0OO9290CP-FRAME_SR005
    return upc.split('-')[0];
};
// distributor can use tokens with a / (slash) in the name
// the / is escaped by VM clients, all the distributor APIs works with the escaped character %2F
// eg: TKN~0RB4165CP~2RB4165061_601%2F71AB~2AJ1212111_710%2F13AA~NULL~2LSRB4165_1770..AB~NULL~RBCP..55
// inside the asset zip this slash is replaced with a dash -
const distributorFolderName = (upc) => {
    return upc.replace(/(%2F)/gm, '-');
};

var AppViewSessionKeys;
(function (AppViewSessionKeys) {
    AppViewSessionKeys["GLASSES_OK"] = "vm-glasses-ok";
    AppViewSessionKeys["GLASSES_KO"] = "vm-glasses-ko";
    AppViewSessionKeys["GLASSES_DOWNLOAD_SUCCESS_UPC"] = "_download_success_upc";
    AppViewSessionKeys["GLASSES_DOWNLOAD_FAILURE_UPC"] = "_download_failure_upc";
    AppViewSessionKeys["GLASSES_DOWNLOAD_SUCCESS_TIME"] = "_download_success_time_ms";
    AppViewSessionKeys["GLASSES_DOWNLOAD_FAILURE_TIME"] = "_download_failure_time_ms";
    AppViewSessionKeys["GLASSES_DOWNLOAD_FALLBACK_SUCCESS_UPC"] = "_download_fallback_success_upc";
    AppViewSessionKeys["GLASSES_DOWNLOAD_FALLBACK_FAILURE_UPC"] = "_download_fallback_failure_upc";
    AppViewSessionKeys["GLASSES_DOWNLOAD_FALLBACK_SUCCESS_TIME"] = "_download_fallback_success_time_ms";
    AppViewSessionKeys["GLASSES_DOWNLOAD_FALLBACK_FAILURE_TIME"] = "_download_fallback_failure_time_ms";
})(AppViewSessionKeys || (AppViewSessionKeys = {}));

const logger$2 = RemoteLogConfig.getInstance().getLoggerInfo(name, version, 'GlassesExtractor');
const ALL_TEXTURES = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
class GlassesExtractor {
    unzip(upc, glassesZip, resolution, singleTexture) {
        const colorIndexes = (typeof singleTexture === 'number') ? [singleTexture] : ALL_TEXTURES;
        return this.unzipGlasses(upc, glassesZip, colorIndexes, resolution);
    }
    unzipGlasses(upc, glassesZip, colorIndexes, resolution) {
        const time1 = performance.now();
        let time2 = 0;
        const jszip = new JSZip();
        return jszip.loadAsync(glassesZip).then(() => {
            logger$2.info('glasses zip [upc={}] loaded in {} ms', upc, performance.now() - time1);
            time2 = performance.now();
            return this.extractFilesFromZipArchive(jszip, upc, colorIndexes);
        }).then((glassesExtracted) => {
            logger$2.info('glasses zip [upc={}] opened in {} ms', upc, performance.now() - time2);
            const glasses = this.createGlassesDataFromExtractedArchive(upc, glassesExtracted, resolution, colorIndexes);
            return glasses;
        });
    }
    extractFilesFromZipArchive(jszip, zipUpc, colorIndexes) {
        const promises = [];
        const folderName = distributorFolderName(zipUpc);
        promises.push(this.extractB3D(jszip, folderName));
        promises.push(this.extractMult(jszip, folderName), this.extractShadow(jszip, folderName), this.extractLensMap(jszip, folderName), this.extractBoundingBoxes(jszip, folderName), this.extractLandmarks(jszip, folderName));
        this.extractColors(jszip, folderName, colorIndexes).forEach((promise) => {
            promises.push(promise);
        });
        return Promise.all(promises);
    }
    extractColors(jszip, folderName, colorIndexes) {
        const promises = [];
        colorIndexes.map((i) => {
            const time1 = performance.now();
            const zipFolder = jszip.folder(folderName);
            if (!zipFolder) {
                throw new GlassesDownloadError(`${folderName} folder does not exists`);
            }
            const file = zipFolder.file(assetNames.color(i));
            if (!file) {
                throw new GlassesDownloadError(`${assetNames.color(i)} file does not exists`);
            }
            const colorPromise = AssetDecoder.getZippedImage(file);
            colorPromise.then((color) => {
                const time2 = performance.now();
                const ttime = time2 - time1;
                logger$2.debug('texture {} extracted in {} ms from upc {}: (length={})', i, ttime, folderName, color.src.length);
            });
            promises.push(colorPromise);
        });
        return promises;
    }
    extractMult(jszip, folderName) {
        const zipFolder = jszip.folder(folderName);
        if (!zipFolder) {
            throw new GlassesDownloadError(`${folderName} folder does not exists`);
        }
        const file = zipFolder.file(assetNames.transparency);
        if (!file) {
            throw new GlassesDownloadError(`${assetNames.transparency} file does not exists`);
        }
        const multPromise = AssetDecoder.getZippedImage(file);
        const time1 = performance.now();
        multPromise.then((mult) => {
            const time2 = performance.now();
            const ttime = time2 - time1;
            logger$2.debug('mult extracted in {} ms from upc {}: (length={})', ttime, folderName, mult.src.length);
        });
        return multPromise;
    }
    extractShadow(jszip, folderName) {
        const zipFolder = jszip.folder(folderName);
        if (!zipFolder) {
            throw new GlassesDownloadError(`${folderName} folder does not exists`);
        }
        const file = zipFolder.file(assetNames.shadow);
        if (!file) {
            throw new GlassesDownloadError(`${assetNames.shadow} file does not exists`);
        }
        const shadowPromise = AssetDecoder.getZippedImage(file);
        const time1 = performance.now();
        shadowPromise.then((shadow) => {
            const time2 = performance.now();
            const ttime = time2 - time1;
            logger$2.debug('shadow extracted in {} ms from upc {}: (length={})', ttime, folderName, shadow.src.length);
        });
        return shadowPromise;
    }
    // lensmaps, boundig boxes, and landmarks are optional and are not always present in zip file
    extractLensMap(jszip, folderName) {
        const zipFolder = jszip.folder(folderName);
        if (!zipFolder) {
            throw new GlassesDownloadError(`${folderName} folder does not exists`);
        }
        const lensmapFile = zipFolder.file(assetNames.lensMap);
        if (!!lensmapFile) {
            const lensmapPromise = AssetDecoder.getZippedImage(lensmapFile);
            const time1 = performance.now();
            lensmapPromise.then((lensmap) => {
                const time2 = performance.now();
                const ttime = time2 - time1;
                logger$2.debug('lens map extracted in {} ms from upc {}: (length={})', ttime, folderName, lensmap.byteLength);
            });
            return lensmapPromise;
        }
        return Promise.resolve(undefined);
    }
    // lensmaps, boundig boxes, and landmarks are optional and are not always present in zip file
    extractBoundingBoxes(jszip, folderName) {
        const zipFolder = jszip.folder(folderName);
        if (!zipFolder) {
            throw new GlassesDownloadError(`${folderName} folder does not exists`);
        }
        const lensBoundsFile = zipFolder.file(assetNames.lensBounds);
        if (!!lensBoundsFile) {
            const lensBoundsPromise = AssetDecoder.getZippedGLTF(folderName, lensBoundsFile);
            const time1 = performance.now();
            lensBoundsPromise.then((bounds) => {
                const time2 = performance.now();
                const ttime = time2 - time1;
                logger$2.debug('lens bounds extracted in {} ms from upc {}: (length={})', ttime, folderName, bounds.byteLength);
            });
            return lensBoundsPromise;
        }
        return Promise.resolve(undefined);
    }
    // lensmaps, boundig boxes, and landmarks are optional and are not always present in zip file
    extractLandmarks(jszip, folderName) {
        const landmarksFile = jszip.folder(folderName).file(assetNames.glassesLandmarks);
        if (!!landmarksFile) {
            const landmarksPromise = AssetDecoder.getZippedGLTF(folderName, landmarksFile);
            const time1 = performance.now();
            landmarksPromise.then((landmarks) => {
                const time2 = performance.now();
                const ttime = time2 - time1;
                logger$2.debug('landmarks extracted in {} ms from upc {}: (length={})', ttime, folderName, landmarks.byteLength);
            });
            return landmarksPromise;
        }
        return Promise.resolve(undefined);
    }
    extractB3D(jszip, folderName) {
        const b3dPromise = jszip.folder(folderName).file(assetNames.b3d).async('arraybuffer');
        const time1 = performance.now();
        b3dPromise.then((b3d) => {
            const time2 = performance.now();
            const ttime = time2 - time1;
            logger$2.debug('model extracted in {} ms from upc {}: (length={})', ttime, folderName, b3d.byteLength);
        });
        return b3dPromise;
    }
    createGlassesDataFromExtractedArchive(upc, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    glassesExtracted, resolution, textureIndexes) {
        logger$2.info('creating glasses from {} items...', glassesExtracted.length);
        const glasses = {
            objModel: glassesExtracted[0],
            transparency: glassesExtracted[1],
            shadow: glassesExtracted[2],
            lensMap: glassesExtracted[3],
            lensBoundingBox: glassesExtracted[4],
            glassesLandmarks: glassesExtracted[5],
            textures: glassesExtracted.slice(6, 6 + textureIndexes.length),
            upc,
            resolution,
        };
        return glasses;
    }
}

/* import { GlassesAsset } from "./GlassesAsset"; */
const logger$3 = RemoteLogConfig.getInstance().getLoggerInfo(name, version, 'ZipDownloader');
/*

Some sample tokens for custom glasses coming from the distributor

available
TKN~0RB2140CP~2RB2140P61_902...AA~2AP3031111_954...AA~NULL~1RB00500681_GRIDFK~NULL~50
TKN~0RB2140CP~2RB2140P61_902...AA~2AP3031111_954...AA~NULL~1RB00500633_GRIDFK~NULL~50

not available (uses fallback)
TKN~0RB3592CP~1RB3592061_001...55~NULL~1TE3941A00_A1812.AA~1LSRB3592_2540..AB~NULL~RBCP..55
TKN~0RB3592CP~1RB3592061_001...50~NULL~1TE3941A00_A1814.AA~1LSRB3592_1766..AA~NULL~RBCP..50

with slashes (%2F)
TKN~0RB4165CP~2RB4165061_601%2F71AB~2AJ1212111_710%2F13AA~NULL~2LSRB4165_1770..AB~NULL~RBCP..55

TKN~0RB4165CP~2RB4165061_601%2F71AB~2AJ1212111_710%2F8GAA~NULL~2LSRB4165_1770..AB~NULL~RBCP..55

TKN~0RX6465CP~1RX6465061_2945..51~NULL~1TE4183A00_X523%2FHAA~2064-DE~NULL~RBCP..51~K-MC5~K-RB0

*/
/*

Some sample tokens for custom glasses coming from the distributor

available
TKN~0RB2140CP~2RB2140P61_902...AA~2AP3031111_954...AA~NULL~1RB00500681_GRIDFK~NULL~50
TKN~0RB2140CP~2RB2140P61_902...AA~2AP3031111_954...AA~NULL~1RB00500633_GRIDFK~NULL~50

not available (uses fallback)
TKN~0RB3592CP~1RB3592061_001...55~NULL~1TE3941A00_A1812.AA~1LSRB3592_2540..AB~NULL~RBCP..55
TKN~0RB3592CP~1RB3592061_001...50~NULL~1TE3941A00_A1814.AA~1LSRB3592_1766..AA~NULL~RBCP..50

with slashes (%2F)
TKN~0RB4165CP~2RB4165061_601%2F71AB~2AJ1212111_710%2F13AA~NULL~2LSRB4165_1770..AB~NULL~RBCP..55

TKN~0RB4165CP~2RB4165061_601%2F71AB~2AJ1212111_710%2F8GAA~NULL~2LSRB4165_1770..AB~NULL~RBCP..55

TKN~0RX6465CP~1RX6465061_2945..51~NULL~1TE4183A00_X523%2FHAA~2064-DE~NULL~RBCP..51~K-MC5~K-RB0

*/
/*

Some sample tokens for custom glasses coming from the distributor

available
TKN~0RB2140CP~2RB2140P61_902...AA~2AP3031111_954...AA~NULL~1RB00500681_GRIDFK~NULL~50
TKN~0RB2140CP~2RB2140P61_902...AA~2AP3031111_954...AA~NULL~1RB00500633_GRIDFK~NULL~50

not available (uses fallback)
TKN~0RB3592CP~1RB3592061_001...55~NULL~1TE3941A00_A1812.AA~1LSRB3592_2540..AB~NULL~RBCP..55
TKN~0RB3592CP~1RB3592061_001...50~NULL~1TE3941A00_A1814.AA~1LSRB3592_1766..AA~NULL~RBCP..50

with slashes (%2F)
TKN~0RB4165CP~2RB4165061_601%2F71AB~2AJ1212111_710%2F13AA~NULL~2LSRB4165_1770..AB~NULL~RBCP..55

TKN~0RB4165CP~2RB4165061_601%2F71AB~2AJ1212111_710%2F8GAA~NULL~2LSRB4165_1770..AB~NULL~RBCP..55

TKN~0RX6465CP~1RX6465061_2945..51~NULL~1TE4183A00_X523%2FHAA~2064-DE~NULL~RBCP..51~K-MC5~K-RB0

*/
class ZipDownloader {
    constructor() {
        this.remoteLog = new RemoteLog();
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = new ZipDownloader();
        }
        return this.instance;
    }
    downloadZippedGlasses(upc, resolution, singleTexture, envConfig) {
        return new Promise((resolve, reject) => {
            this.tryToDownload(upc, resolution, envConfig)
                .then((blob) => {
                resolve(new GlassesExtractor().unzip(upc, blob, resolution, singleTexture));
            }).catch((e) => {
                logger$3.error(e);
                reject(new GlassesDownloadError(upc));
            });
        });
    }
    tryToDownload(upc, resolution, envConfig) {
        const time1 = performance.now();
        let glassesUrl;
        let requestOptions;
        const customDistributorAsset = isDistributorAsset(upc);
        const qaDistributorAsset = isQADistributorAsset(upc);
        if (customDistributorAsset) {
            // custom assets requests requires a token, these asset are distributed through a system
            // that automatically generates combinations of custom assets if not available
            glassesUrl = this.getCustomUrl(upc, envConfig);
            requestOptions = {
                headers: {
                    'x-api-key': envConfig.customDistributorKey
                }
            };
        }
        else if (qaDistributorAsset) {
            // this URL is used locally by people that creates the pieces that
            // are combined by above distributor
            glassesUrl = this.getDistributorUrl(upc, envConfig);
        }
        else {
            // this is the classic b3d asset cdn
            glassesUrl = this.getUrl(upc, resolution, envConfig);
        }
        let triedLegacyCustom = true;
        const fetchGlasses = () => {
            return fetch(glassesUrl, requestOptions)
                .then((response) => {
                if (response.ok) {
                    logger$3.debug('glasses archive {} downloaded', response.url);
                    const time2 = performance.now();
                    const ttime = time2 - time1;
                    this.traceDownloadSuccess(upc, ttime);
                    return response.blob();
                }
                else {
                    logger$3.error('glasses download {} failed: [{} {}]', response.url, response.status, response.statusText);
                    const time2 = performance.now();
                    const ttime = time2 - time1;
                    this.traceDownloadFailure(upc, ttime);
                    switch (response.status) {
                        case 403:
                            throw new GlassesDownloadForbiddenError(upc);
                        case 404:
                            throw new GlassesNotFoundError(upc);
                        default:
                            throw new GlassesDownloadError(upc);
                    }
                }
            })
                .catch((reason) => {
                logger$3.error('glasses download {} error {}', glassesUrl, reason);
                // if we are downloading a custom asset (TKN) is worth try to download it from legacy bucket
                if (customDistributorAsset && triedLegacyCustom) {
                    triedLegacyCustom = false;
                    logger$3.debug('try to download the custom asset from legacy bucket');
                    glassesUrl = this.getLegacyUrl(upc, '256', envConfig);
                    // remove the token from the request because it breaks S3 bucket
                    requestOptions = {};
                    return fetchGlasses();
                }
                else {
                    // is possible that the catched error is already been initialised by above promise
                    if (reason.genericError) {
                        throw reason;
                    }
                    throw new GlassesDownloadError(glassesUrl);
                }
            });
        };
        return new Promise((resolve, reject) => {
            fetchGlasses()
                .then((blob) => {
                if (!!blob) {
                    resolve(blob);
                }
                reject(new GlassesDownloadError(`${upc} returned empty blob`));
            })
                .catch((reason) => {
                logger$3.error('glasses download {} error {}', glassesUrl, reason);
                reject(reason);
            });
        });
    }
    getUrl(upc, resolution, envConfig) {
        return `${envConfig.b3dHost}/${resolution}/${upc}.zip`;
    }
    getLegacyUrl(upc, resolution, envConfig) {
        return `${envConfig.b3dHost}/${resolution}/${upc}.zip`;
    }
    getCustomUrl(tkn, envConfig) {
        return `${envConfig.customDistributorHost}${envConfig.customDistributorGetPermutation}${tkn}`;
    }
    getDistributorUrl(upc, envConfig) {
        const baseName = distributorBasename(upc);
        return `${envConfig.b3dHost}/${baseName}/${upc}.zip`;
    }
    traceDownloadSuccess(upc, ttime) {
        this.remoteLog.sendAppViewSession({
            statusCode: AppViewSessionKeys.GLASSES_OK + AppViewSessionKeys.GLASSES_DOWNLOAD_SUCCESS_UPC,
            statusText: upc,
        }, {
            statusCode: AppViewSessionKeys.GLASSES_OK + AppViewSessionKeys.GLASSES_DOWNLOAD_SUCCESS_TIME,
            statusText: ttime.toString(),
        });
    }
    traceDownloadFailure(upc, ttime) {
        this.remoteLog.sendAppViewSession({
            statusCode: AppViewSessionKeys.GLASSES_KO + AppViewSessionKeys.GLASSES_DOWNLOAD_FAILURE_UPC,
            statusText: upc,
        }, {
            statusCode: AppViewSessionKeys.GLASSES_KO + AppViewSessionKeys.GLASSES_DOWNLOAD_FAILURE_TIME,
            statusText: ttime.toString(),
        });
    }
}

// import { GlassesAsset } from "./GlassesAsset";
// import { GlassesLandmarks } from "./GlassesLandmarks";
// import { GLTFJson } from "./GLTFJson";
// import { isCustomDistributorAsset } from "./helpers/AssetHelper";
// import { LensBoundingBox } from "./LensBoundingBox";
const logger$4 = RemoteLogConfig.getInstance().getLoggerInfo(name, version, 'GlassesDownloader');
// temporary mock function for GLTF misc/DC assets
const miscUrls = (envConfig, upc) => {
    return {
        boundsUrl: `${envConfig.gltfHost}/${upc}/webGL/${upc}_misc/bounds.glb`,
        landmarksUrl: `${envConfig.gltfHost}/${upc}/webGL/${upc}_misc/landmarks.glb`,
    };
};
class GlassesDownloader {
    constructor() {
        this.remoteLog = new RemoteLog();
    }
    downloadGltfGlasses(options) {
        if (options.glassesEnvironment === GlassesEnvironment.MOCK) {
            return Promise.resolve(this.getMockGltfGlassesUrl(options));
        }
        else {
            const envConfig = getEnvironmentConfig(options.glassesEnvironment);
            const gltfUrl = `${envConfig.gltfHost}/${options.upc}${envConfig.gltfPointer}`;
            return fetch(gltfUrl).then((response) => {
                if (response.ok) {
                    return response.json();
                }
                else {
                    return Promise.reject(new GlassesDownloadError(`${options.upc} - ${response.status}`));
                }
            }).then((json) => {
                const assetData = json[options.upc];
                // at the moment this is the only way we can understand if the catalog gave us an empty response
                // TODO: ask backend team to improve the answer
                if (!assetData.LOD1 && !assetData.LOD2) {
                    return Promise.reject(new GlassesDownloadError(`${options.upc} - missing fundamental LOD`));
                }
                return {
                    upc: options.upc,
                    lod: 0,
                    gltfLodUrls: {
                        lod1: assetData.LOD1.gltfUrl,
                        ...(!!assetData.LOD2 && { lod2: assetData.LOD2.gltfUrl })
                    },
                    nosepadType: assetData.nosepadType,
                    fitting: assetData.fitting,
                    flare: assetData.flare,
                    ...(!!assetData.misc && !!options.landmarksAndBBox && { misc: assetData.misc })
                };
            });
        }
    }
    getMockGltfGlassesUrl(options) {
        var _a, _b, _c, _d;
        const envConfig = getEnvironmentConfig(options.glassesEnvironment);
        const assetNumLods = MockAssetData[options.upc].lodNumber;
        const gltfLodUrls = {
            lod1: ''
        };
        if (assetNumLods === 1) {
            // asset without lods (third-party)
            gltfLodUrls.lod1 = `${envConfig.gltfHost}/${options.upc}/webGL/${options.upc}_LOD0/${options.upc}.gltf`;
        }
        else {
            gltfLodUrls.lod1 = `${envConfig.gltfHost}/${options.upc}/webGL/${options.upc}_LOD1/${options.upc}.gltf`;
            if (assetNumLods >= 2) {
                gltfLodUrls.lod2 = `${envConfig.gltfHost}/${options.upc}/webGL/${options.upc}_LOD2/${options.upc}.gltf`;
            }
        }
        return {
            upc: options.upc,
            gltfLodUrls: gltfLodUrls,
            lod: assetNumLods,
            nosepadType: (!!((_a = MockAssetData[options.upc]) === null || _a === void 0 ? void 0 : _a.nosepad_type)) ? MockAssetData[options.upc].nosepad_type : gltfDefaults.nosepad_type,
            fitting: (!!((_b = MockAssetData[options.upc]) === null || _b === void 0 ? void 0 : _b.fitting)) ? MockAssetData[options.upc].fitting : gltfDefaults.fitting,
            flare: (!!((_c = MockAssetData[options.upc]) === null || _c === void 0 ? void 0 : _c.flare)) ? MockAssetData[options.upc].flare : gltfDefaults.flare,
            misc: !!((_d = MockAssetData[options.upc]) === null || _d === void 0 ? void 0 : _d.misc) &&
                options.landmarksAndBBox !== undefined &&
                options.landmarksAndBBox ?
                miscUrls(envConfig, options.upc) : undefined,
        };
    }
    downloadGlasses(options) {
        const envConfig = getEnvironmentConfig(options.glassesEnvironment);
        if (this.shouldDownloadZip(options.upc, envConfig)) {
            return this.downloadZippedGlasses(options.upc, options.resolution, options.singleTexture, (options.lensMap) ? true : false, (options.lensBoundingBoxes) ? true : false, (options.glassesLandmarks) ? true : false, envConfig);
        }
        else {
            return this.downloadSeparatedGlasses(options.upc, options.resolution, options.singleTexture, (options.lensMap) ? true : false, (options.lensBoundingBoxes) ? true : false, (options.glassesLandmarks) ? true : false, envConfig);
        }
    }
    shouldDownloadZip(upc, envConfig) {
        return isDistributorAsset(upc) || envConfig.assetType === 'ZIPPED';
    }
    downloadZippedGlasses(upc, resolution = '512', singleTexture, lensMap, lensBoundingBoxes, glassesLandmarks, envConfig) {
        // prepare lensmap url
        const lensMapUrl = `${envConfig.b3dHost}/${resolution}/${upc}/${assetNames.lensMap}`;
        const lensBoundsUrl = `${envConfig.b3dHost}/${resolution}/${upc}/${assetNames.lensBounds}`;
        const glassesLandmarksUrl = `${envConfig.b3dHost}/${resolution}/${upc}/${assetNames.glassesLandmarks}`;
        const qaToolEnv = ['QA_B3D_PROD', 'QA_GLTF_PROD', 'QA_B3D_TEST', 'QA_GLTF_TEST', 'QA_PROD', 'QA_TEST'];
        const qaTool = qaToolEnv.includes(envConfig.name);
        // download the zip and lensmap if present
        return Promise.all([
            ZipDownloader.getInstance().downloadZippedGlasses(upc, resolution, singleTexture, envConfig),
            (lensMap && !qaTool) ? this.downloadB3dAsset(lensMapUrl) : Promise.resolve(new Blob()),
            (lensBoundingBoxes && !qaTool) ? this.downloadB3dAsset(lensBoundsUrl) : Promise.resolve(new Blob()),
            (glassesLandmarks && !qaTool) ? this.downloadB3dAsset(glassesLandmarksUrl) : Promise.resolve(new Blob()),
        ]).then((responses) => {
            // load the glasses image
            return Promise.all([
                Promise.resolve(responses[0]),
                (responses[1].size > 0) ? AssetDecoder.getImage(responses[1]) : undefined,
                (responses[2].size > 0) ? AssetDecoder.getGLTFAsset(upc, responses[2]) : undefined,
                (responses[3].size > 0) ? AssetDecoder.getGLTFAsset(upc, responses[3]) : undefined,
            ]);
        }).then((glassesAndLensMap) => {
            // TODO is necessary to track download success?
            // compose the asset with lensmaps
            const glassesAsset = glassesAndLensMap[0];
            //if landmarks and bboxes option are false we set relative field undefined
            glassesAsset.lensBoundingBox = lensBoundingBoxes ? glassesAsset.lensBoundingBox : undefined;
            glassesAsset.glassesLandmarks = glassesLandmarks ? glassesAsset.glassesLandmarks : undefined;
            // NOTE: QA tool still uses zipped glasses, if we are outside QA tool new assets must be unzipped
            if (!qaTool) {
                glassesAsset.lensMap = glassesAndLensMap[1];
                glassesAsset.lensBoundingBox = glassesAndLensMap[2];
                glassesAsset.glassesLandmarks = glassesAndLensMap[3];
            }
            return Promise.resolve(glassesAsset);
        });
    }
    downloadSeparatedGlasses(upc, resolution, singleTexture, lensMap, lensBoundingBoxes, glassesLandmarks, envConfig) {
        // const normalizedUpc = normalizeSize(normalizeRemix(upc));
        const b3dUrl = `${envConfig.b3dHost}/${resolution}/${upc}/${assetNames.b3d}`;
        const transparencyUrl = `${envConfig.b3dHost}/${resolution}/${upc}/${assetNames.transparency}`;
        const shadowUrl = `${envConfig.b3dHost}/${resolution}/${upc}/${assetNames.shadow}`;
        const lensMapUrl = `${envConfig.b3dHost}/${resolution}/${upc}/${assetNames.lensMap}`;
        const lensBoundsUrl = `${envConfig.b3dHost}/${resolution}/${upc}/${assetNames.lensBounds}`;
        const glassesLandmarksUrl = `${envConfig.b3dHost}/${resolution}/${upc}/${assetNames.glassesLandmarks}`;
        const textureIndexes = (singleTexture !== undefined) ?
            [singleTexture] : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
        const textureUrls = textureIndexes.map((x) => {
            return `${envConfig.b3dHost}/${resolution}/${upc}/${assetNames.color(x)}`;
        });
        const time1 = performance.now();
        return Promise.all([
            this.downloadB3dAsset(b3dUrl),
            this.downloadB3dAsset(transparencyUrl),
            this.downloadB3dAsset(shadowUrl),
            (lensMap) ? this.downloadB3dAsset(lensMapUrl) : Promise.resolve(new Blob()),
            (lensBoundingBoxes) ? this.downloadB3dAsset(lensBoundsUrl) : Promise.resolve(new Blob()),
            (glassesLandmarks) ? this.downloadB3dAsset(glassesLandmarksUrl) : Promise.resolve(new Blob()),
            ...textureUrls.map((url) => this.downloadB3dAsset(url))
        ]).then((responses) => {
            return Promise.all([
                AssetDecoder.getArrayBuffer(responses[0]),
                AssetDecoder.getImage(responses[1]),
                AssetDecoder.getImage(responses[2]),
                (responses[3].size > 0) ? AssetDecoder.getImage(responses[3]) : undefined,
                (responses[4].size > 0) ? AssetDecoder.getGLTFAsset(upc, responses[4]) : undefined,
                (responses[5].size > 0) ? AssetDecoder.getGLTFAsset(upc, responses[5]) : undefined,
                Promise.all(responses.slice(6, responses.length).map((textureResponse) => {
                    return AssetDecoder.getImage(textureResponse);
                }))
            ]);
        }).then((assetsResponses) => {
            this.traceDownloadSuccess(upc, performance.now() - time1);
            return {
                upc: upc,
                objModel: assetsResponses[0],
                transparency: assetsResponses[1],
                shadow: assetsResponses[2],
                lensMap: assetsResponses[3],
                lensBoundingBox: assetsResponses[4],
                glassesLandmarks: assetsResponses[5],
                textures: assetsResponses[6],
                resolution: resolution
            };
        }).catch((e) => {
            this.traceDownloadFailure(upc, performance.now() - time1);
            logger$4.error(e);
            return Promise.reject(e);
        });
    }
    // TODO, is this used anymore?
    glassesArchiveUrls(upc, resolution, singleTexture, lensMap, envConfig) {
        // const normalizedUpc = normalizeSize(normalizeRemix(upc));
        const b3dUrl = `${envConfig.b3dHost}/${resolution}/${upc}/${assetNames.b3d}`;
        const transparencyUrl = `${envConfig.b3dHost}/${resolution}/${upc}/${assetNames.transparency}`;
        const shadowUrl = `${envConfig.b3dHost}/${resolution}/${upc}/${assetNames.shadow}`;
        const lensMapUrl = (lensMap) ? `${envConfig.b3dHost}/${resolution}/${upc}/${assetNames.lensMap}` : '';
        const textureIndexes = (singleTexture !== undefined) ?
            [singleTexture] : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
        const textureUrls = textureIndexes.map((x) => {
            return `${envConfig.b3dHost}/${resolution}/${upc}/${assetNames.color(x)}`;
        });
        return [
            b3dUrl,
            transparencyUrl,
            shadowUrl,
            lensMapUrl,
            ...textureUrls
        ];
    }
    downloadB3dAsset(glassesAssetUrl) {
        return fetch(glassesAssetUrl)
            .then((response) => {
            if (response.ok) {
                return response.blob();
            }
            else {
                logger$4.error('b3d asset {} failed: [{} {}]', response.url, response.status, response.statusText);
                switch (response.status) {
                    case 403:
                        return Promise.reject(new GlassesDownloadForbiddenError(glassesAssetUrl));
                    case 404:
                        return Promise.reject(new GlassesNotFoundError(glassesAssetUrl));
                    default:
                        return Promise.reject(new GlassesDownloadError(glassesAssetUrl));
                }
            }
        }).catch((e) => {
            logger$4.error(e);
            return Promise.reject(new GlassesDownloadError(glassesAssetUrl));
        });
    }
    // private downloadGltfAsset(glassesAssetUrl: string): Promise<ArrayBuffer> {
    //   return fetch(glassesAssetUrl)
    //     .then((response: Response) => {
    //       if (response.ok) {
    //         return response.arrayBuffer();
    //       } else {
    //         logger.error('gltf asset {} failed: [{} {}]',
    //           response.url, response.status, response.statusText);
    //         switch (response.status) {
    //           case 403:
    //             return Promise.reject(new GlassesDownloadForbiddenError(glassesAssetUrl));
    //           case 404:
    //             return Promise.reject(new GlassesNotFoundError(glassesAssetUrl));
    //           default:
    //             return Promise.reject(new GlassesDownloadError(glassesAssetUrl));
    //         }
    //       }
    //     }).catch((e) => {
    //       logger.error(e);
    //       return Promise.reject(new GlassesDownloadError(glassesAssetUrl));
    //     });
    // }
    traceDownloadSuccess(upc, ttime) {
        this.remoteLog.sendAppViewSession({
            statusCode: AppViewSessionKeys.GLASSES_OK + AppViewSessionKeys.GLASSES_DOWNLOAD_SUCCESS_UPC,
            statusText: upc,
        }, {
            statusCode: AppViewSessionKeys.GLASSES_OK + AppViewSessionKeys.GLASSES_DOWNLOAD_SUCCESS_TIME,
            statusText: ttime.toString(),
        });
    }
    traceDownloadFailure(upc, ttime) {
        this.remoteLog.sendAppViewSession({
            statusCode: AppViewSessionKeys.GLASSES_KO + AppViewSessionKeys.GLASSES_DOWNLOAD_FAILURE_UPC,
            statusText: upc,
        }, {
            statusCode: AppViewSessionKeys.GLASSES_KO + AppViewSessionKeys.GLASSES_DOWNLOAD_FAILURE_TIME,
            statusText: ttime.toString(),
        });
    }
}

export { Catalog, GlassesDownloader, GlassesEnvironment };
//# sourceMappingURL=vm-glasses.js.map
